// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { CardFrontTestIds, QuickCardEditorTestIds } from '@trello/test-ids';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { CardInListCoverTemplate } from './CardInListCoverTemplate';
import { MemberOnCardTemplate } from './MemberOnCardTemplate';
const t = teacupWithHelpers('card_in_list');

// eslint-disable-next-line @trello/no-module-logic
export const CardInListTemplate = t.renderable(function ({
  hasStickers,
  quickEdit,
  name,
  members,
  showEditor,
  badgesHTML,
  hasCover,
  cover,
  hideCover,
  attachmentCoverUrl,
  cardRole,
  canAssign,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (cardRole !== 'board') {
    CardInListCoverTemplate({
      cover,
      hasCover,
      hideCover,
      hasStickers,
      attachmentCoverUrl,
    });
  }

  if (showEditor) {
    t.icon('edit', {
      class:
        'list-card-operation dark-hover js-open-quick-card-editor js-card-menu',
      'data-testid': CardFrontTestIds.QuickCardEditorButton,
    });
  }
  if (cardRole !== 'board') {
    t.div(
      '.list-card-stickers-area.js-stickers-area',
      { class: t.classify({ hide: !hasStickers }) },
      () => t.div('.stickers.js-card-stickers'),
    );
  }
  t.div('.list-card-details.js-card-details', function () {
    t.div(
      '.list-card-front-labels-container.js-list-card-front-labels-container',
    );

    if (quickEdit) {
      t.textarea(
        '.list-card-edit-title.js-edit-card-title',
        { dir: 'auto', 'data-testid': QuickCardEditorTestIds.EditCardTitle },
        () => t.text(name),
      );
    } else {
      t.span('.list-card-title.js-card-name', {
        dir: 'auto',
        'data-testid': CardFrontTestIds.CardName,
      });
    }
    t.div('.badges', function () {
      t.span('.js-badges', () => t.raw(badgesHTML));
      t.span('.custom-field-front-badges.js-custom-field-badges');
      return t.span('.js-plugin-badges');
    });
    return t.div(
      '.list-card-members.js-list-card-members',
      {
        class: t.classify({ 'js-list-draggable-card-members': canAssign }),
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      () => members.map((member: any) => MemberOnCardTemplate(member)),
    );
  });

  t.p('.list-card-dropzone', () => t.format('drop-files-to-upload'));

  t.p('.list-card-dropzone-limited', () => t.format('too-many-attachments'));

  return t.p('.list-card-dropzone-restricted', () =>
    t.format('attachments-restricted'),
  );
});
